import { jwtDecode as g } from "jwt-decode";
const s = "access_token", a = "refresh_token", c = "id_token", l = "sub";
let r = "";
const m = (e) => typeof e == "object" && !!e && "sub" in e && "exp" in e, t = (e) => r ? `${e}:${r}` : e;
function I(e) {
  r = (e == null ? void 0 : e.trim()) || "";
}
const u = (e) => {
  const o = g(e);
  if (!m(o) || !o.sub)
    throw new Error("Invalid token payload");
  return o;
};
function T(e) {
  return g(e);
}
function E() {
  const e = S();
  if (!e)
    return !0;
  const { exp: o } = u(e);
  return (/* @__PURE__ */ new Date()).getTime() / 1e3 >= o;
}
function k() {
  return localStorage.getItem(t(l));
}
function S() {
  return localStorage.getItem(t(s));
}
function d() {
  return localStorage.getItem(t(a));
}
function _() {
  return localStorage.getItem(t(c));
}
function b() {
  localStorage.removeItem(t(s)), localStorage.removeItem(t(l)), localStorage.removeItem(t(a)), localStorage.removeItem(t(c));
}
function p(e, o, n) {
  if (e) {
    localStorage.setItem(t(s), e);
    const { sub: i } = u(e);
    localStorage.setItem(t(l), i);
  }
  o && localStorage.setItem(t(a), o), n && localStorage.setItem(t(c), n);
}
export {
  s as A,
  c as I,
  a as R,
  l as S,
  p as a,
  _ as b,
  d as c,
  T as d,
  E as e,
  k as f,
  S as g,
  u as p,
  b as r,
  I as s
};
//# sourceMappingURL=tokens-C4KyVSzL.js.map
